import { gql } from 'apollo-boost'

const MENU_PROBING_JOB = gql`
  query menuProbingJob($id: ID!) {
    menuProbingJob(id: $id) {
      id
      createdDate
      completedDate
      menuProbingResponse {
        id
        data
      }
    }
  }
`

export default MENU_PROBING_JOB
